export default __webpack_public_path__ + "static/salesMangerHero-2703f57fd108719b0397300f1383d3ab.png";